import React from 'react';
import { Link } from 'react-router-dom';

const SubscriptionPlan: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Subscription Plans</h6>
                        <p className="text-secondary small">Lets make it open environment to get helped</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/my-profile"> My Profile</Link></li>
                        <li className="breadcrumb-item bi"><Link to="/app/subscription"> Subscription</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> Plans</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-header position-relative">
                                <div className="coverimg h-100 w-100 position-absolute top-0 start-0 z-index-0 blur-overlay">
                                    <img src={asset('assets/img/background-image/backgorund-image-6.jpg')} alt="" />
                                </div>
                                <div className="position-relative z-index-1">
                                    <p><span className="badge text-bg-success">Active</span></p>
                                    <div className="row gx-3">
                                        <div className="col-auto">
                                            <i className="avatar avatar-50 rounded bg-theme-1 fs-4 bi bi-person vm"></i>
                                        </div>
                                        <div className="col">
                                            <h5 className="mb-1">Personal</h5>
                                            <p className="text-secondary">Perfect for the individuals</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                                    <div className="col-auto">
                                        <h1><span className="text-secondary">$</span> 50</h1>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary">per license</p>
                                    </div>
                                </div>
                                <h6>Basic includes:</h6>
                                <ul className="list-group adminuiux-list-group">
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> All demo access</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> Unlimited Download</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> No Contact list</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> 10 transactions per day</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> 24/7 Customer Support</li>
                                </ul>
                            </div>
                            <div className="card-footer text-center d-grid">
                                <button className="btn btn-theme">Buy Now!</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card mb-3 mb-lg-4 overflow-hidden ">
                            <div className="card-header position-relative">
                                <div className="coverimg h-100 w-100 position-absolute top-0 start-0 z-index-0 blur-overlay">
                                    <img src={asset('assets/img/background-image/backgorund-image-2.jpg')} alt="" />
                                </div>
                                <div className="position-relative z-index-1">
                                    <p><span className="badge text-bg-theme-1 theme-blue">Recommended</span></p>
                                    <div className="row gx-3">
                                        <div className="col-auto">
                                            <i className="avatar avatar-50 rounded bg-theme-1 fs-4 bi bi-person vm"></i>
                                        </div>
                                        <div className="col">
                                            <h5 className="mb-1">Business</h5>
                                            <p className="text-secondary">Multiple team &amp; customer</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row align-items-center mb-4">
                                    <div className="col-auto">
                                        <h1><span className="text-secondary">$</span> 100</h1>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary">per license</p>
                                    </div>
                                </div>
                                <h6>Basic includes:</h6>
                                <ul className="list-group adminuiux-list-group">
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> All demo access</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> Unlimited Download</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> No Contact list</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> 10 transactions per day</li>
                                    <li className="list-group-item text-secondary"><i className="bi bi-check-circle vm me-1"></i> 24/7 Customer Support</li>
                                </ul>
                            </div>
                            <div className="card-footer d-grid">
                                <button className="btn btn-theme">Buy Now!</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="card bg-theme-1 mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-header position-relative">
                                <div className="coverimg h-100 w-100 position-absolute top-0 start-0 z-index-0 blur-overlay opacity-50">
                                    <img src={asset('assets/img/background-image/backgorund-image-6.jpg')} alt="" />
                                </div>
                                <div className="position-relative z-index-1">
                                    <p><span className="badge text-bg-theme-1 theme-pink">Best</span></p>
                                    <div className="row gx-3">
                                        <div className="col-auto">
                                            <i className="avatar avatar-50 rounded bg-white-opacity text-white fs-4 bi bi-person vm"></i>
                                        </div>
                                        <div className="col">
                                            <h5 className="mb-1">Ultra Pro</h5>
                                            <p className="opacity-75">Multiple Application</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row align-items-center mb-4">
                                    <div className="col-auto">
                                        <h1><span className="opacity-75">$</span> 150</h1>
                                    </div>
                                    <div className="col">
                                        <p className="opacity-75">per license</p>
                                    </div>
                                </div>
                                <h6>Basic includes:</h6>
                                <ul className="list-group adminuiux-list-group">
                                    <li className="list-group-item text-white"><i className="bi bi-check-circle vm me-1"></i> All demo access</li>
                                    <li className="list-group-item text-white"><i className="bi bi-check-circle vm me-1"></i> Unlimited Download</li>
                                    <li className="list-group-item text-white"><i className="bi bi-check-circle vm me-1"></i> No Contact list</li>
                                    <li className="list-group-item text-white"><i className="bi bi-check-circle vm me-1"></i> 10 transactions per day</li>
                                    <li className="list-group-item text-white"><i className="bi bi-check-circle vm me-1"></i> 24/7 Customer Support</li>
                                </ul>
                            </div>
                            <div className="card-footer d-grid">
                                <button className="btn btn-light">Buy Now!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubscriptionPlan;
